// extracted by mini-css-extract-plugin
export var border = "footer-module--border--35642";
export var link = "footer-module--link--3ccde";